import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { iconButtonStyles } from './IconButton.styles';

export type IconButtonVariant = keyof typeof iconButtonStyles.variant;
export type IconButtonSize = keyof typeof iconButtonStyles.size;

export type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  'aria-label': string;
  children: ReactNode;
  variant?: IconButtonVariant;
  size?: IconButtonSize;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      className,
      variant = 'ghost',
      size = 'md',
      type = 'button',
      children,
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      className={cn(
        iconButtonStyles.base,
        iconButtonStyles.variant[variant],
        iconButtonStyles.size[size],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);

IconButton.displayName = 'IconButton';
